import axios from 'axios'

export default {
    name: 'export',
    state: {
        export: [],
    },
    getters: {
        getExportDataResult: state => {
            return state.export
        },
    },
    mutations: {
        EXPORTDATA: (state, payload) => {
            if (payload !== undefined) {
                state.export=payload;
            }
        },
    },
    actions: {
        getExportData(store, { auth, param }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + "absensi/export",
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    params: {
                        start_date: param.start_date,
                        end_date: param.end_date
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getExportDataStatus(store, { auth }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + "absensi/cek_export",
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    params: {},
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then((response) => {
                        store.commit('EXPORTDATA', response.data.progress);
                        resolve(response);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getExportFiles(store, { auth, param }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + "absensi/download_absensi",
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    params: {
                        filename : param.file_name
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        deleteExportFiles(store, { auth, param }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + "absensi/hapus_download_absensi",
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    params: {
                        filename : param.filename
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
    }
}
